import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { map, catchError } from 'rxjs';
import { of } from 'rxjs';
import { MemorialService } from '../services/memorials.service';
import { AdminAuthService } from '../services/admin-auth.service';

export const memorialOwnerGuard: CanActivateFn = (route) => {
  const memorialService = inject(MemorialService);
  const adminAuth = inject(AdminAuthService);
  const router = inject(Router);
  const memorialId = route.paramMap.get('id');

  if (!memorialId) {
    router.navigate(['/memorials']);
    return of(false);
  }

  // Check if user is admin - admins can edit any memorial
  if (adminAuth.isAdminAuthenticated() && adminAuth.isAdmin()) {
    return of(true);
  }

  return memorialService.getById(memorialId).pipe(
    map((memorial) => {
      if (memorial.role === 'owner') {
        return true;
      }

      // Redirect to memorial detail page if not owner
      router.navigate(['/memorials', memorialId]);
      return false;
    }),
    catchError(() => {
      // If memorial not found or error, redirect to memorials list
      router.navigate(['/memorials']);
      return of(false);
    })
  );
};
